import { Link } from 'react-router-dom';
import { useDocumentTitle, useSectionTranslation } from '@/hooks';
import { Header } from '@/features/home/Header';
import { Footer } from '@/features/home/Footer';
import { giveawaysTranslations } from './translations';

/**
 * Placeholder for the giveaways section.
 *
 * There is no `Giveaway` model in the Prisma schema, so this renders an honest
 * "nothing is running" state rather than fabricating draws. It exists because
 * the mobile nav tab points here: a tab that 404s is worse than one that admits
 * the feature is not live yet, and the tab itself is needed for the bottom bar
 * to match playerok's five-item layout.
 *
 * When the backend lands a real campaign, replace the body below with the list;
 * the route, locale files and nav wiring already exist.
 */
export function GiveawaysPage() {
  const t = useSectionTranslation(giveawaysTranslations);
  useDocumentTitle(t.title);

  return (
    <>
      <Header />
      <main className="pt-16 min-h-[60vh] flex items-center">
        <div className="container-main py-16 md:py-24">
          <div className="max-w-lg mx-auto text-center">
            <img
              src="/prizes.png"
              alt={t.prizeIconAlt}
              width={72}
              height={72}
              className="mx-auto mb-6 size-[72px] object-contain"
            />
            <span className="text-xs font-semibold uppercase tracking-widest text-accent">
              {t.eyebrow}
            </span>
            <h1 className="mt-3 font-display text-display-md text-brand-white">{t.headline}</h1>
            <p className="mt-4 text-body-md text-brand-muted">{t.body}</p>
            <Link to="/browse" className="btn-primary mt-8">
              {t.back}
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}